module.exports = __webpack_public_path__ + "static/media/home-transfer.452631d9.jpg";